import React from 'react';
import './LoadingView.scss';

export const LoadingView: React.FC = () => {
    return (
        <div className="TopikTest">
            <div className="LoadingView">
                <div className="LoadingSpinner"></div>
                <p>{"Loading test..."}</p>
            </div>
        </div>
    );
};